import React from 'react';
import { ScrollPanel } from 'primereact/scrollpanel';
import { Accordion, AccordionTab } from 'primereact/accordion';
import {capitalizeFirstLetter} from '../../utilities/Helper'
import _ from 'lodash'

const ProPanelWithAccordion = ({type, data})=>{
    const height = (50 *(_.get(data, "length") || 1)) + 30;
    return <>
    <ScrollPanel style={{height: `${height}px`}}>    
    {_.map(data, (c,index)=>{ 
        return _.isEqual(type, "Waitlists")?
        <div key={index}>
               <Accordion>   
                    <AccordionTab id={index} header = {<label>{c.waitListName}, {c.waitListStatusName}</label>}>
                        <label>{capitalizeFirstLetter(c.priority)} - {c.dateAdded}</label>
                    </AccordionTab>
            </Accordion>
        </div> 
        : <div key={index}>
                <Accordion>   
                    <AccordionTab id={index} 
                    header={<><i className="pi pi-calendar"></i><span style={{marginLeft:"5px"}}>{`${c.dateStart} - ${c.dateEnd}`}</span>{c.dependentName && <span style={{marginLeft: "10px"}}>Dependent</span>}</>}> 
                        {c.dependentName && <label style={{marginTop:"5px"}} >{c.dependentName}</label> }
                        <div style={c.dependentName?{marginTop:"5px"} :{}}>                  
                                {c.location}
                        </div> 
                    </AccordionTab> 
                </Accordion>
                </div>})
    }
    </ScrollPanel>
    </>

}

export default ProPanelWithAccordion;